<form class="project-bulk-edit-form" [formGroup]="bulkEditForm" fxLayout="column"
    fxLayoutAlign="space-around stretch">

    @if (updatedProjects.length > 0 || untouchedProjects.length > 0) {
        <syn-header text="Résumé des modifications"/>
    } @else {
        <syn-header
            text="Édition groupée"
            tooltip="Modification groupée de plusieurs projets"
            [caption]="projectPluralisation(projects.length)"
        />
    }

    <mat-stepper #stepper linear>
        <mat-step>
            <div class="form" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                <div fxLayout="column" fxFlex="100">
                    @if (updateUsers) {
                        <label>Delivery Manager</label>
                        <syn-bulk-edit-toggle formControlName="deliveryManagerAction"></syn-bulk-edit-toggle>

                        @if (isModified('deliveryManagerAction')) {
                            <syn-autocomplete label="Delivery Manager" class="autocomplete syn--margin-top"
                                formControlName="deliveryManager"
                                [dataLoader]="loadUserData"
                                [saveIndicator]="false"
                            />
                        }

                        <label>BackUp Delivery Manager</label>
                        <syn-bulk-edit-toggle formControlName="backupDeliveryManagerAction"></syn-bulk-edit-toggle>

                        @if (isModified('backupDeliveryManagerAction')) {
                            <syn-autocomplete label="BackUp Delivery Manager" class="autocomplete syn--margin-top"
                                formControlName="backupDeliveryManager"
                                [dataLoader]="loadUserData"
                                [saveIndicator]="false"
                            />
                        }

                        <label>CdP build</label>
                        <syn-bulk-edit-toggle formControlName="buildProjectManagerAction"></syn-bulk-edit-toggle>

                        @if (isModified('buildProjectManagerAction')) {
                            <syn-autocomplete label="CdP Build" class="autocomplete syn--margin-top"
                                formControlName="buildProjectManager"
                                [dataLoader]="loadUserData"
                                [saveIndicator]="false"
                            />
                        }

                        <label>Gestionnaire d'application</label>
                        <syn-bulk-edit-toggle
                            formControlName="appManagerAction"
                            [options]="appManagerOptions">
                        </syn-bulk-edit-toggle>

                        @if (isAdded('appManagerAction')) {
                            <syn-autocomplete label="Gestionnaire d'application à ajouter" class="autocomplete syn--margin-top"
                                formControlName="addAppManager"
                                [dataLoader]="loadUserData"
                                [saveIndicator]="false"
                            />
                        }

                        @if (isRemoved('appManagerAction')) {
                            <syn-autocomplete label="Gestionnaire d'application à supprimer" class="autocomplete syn--margin-top"
                                formControlName="removeAppManager"
                                [dataLoader]="loadUserData"
                                [saveIndicator]="false"
                            />
                        }
                    } @else {
                        <label>Business project</label>
                        <syn-bulk-edit-toggle formControlName="businessProjectAction"></syn-bulk-edit-toggle>

                        @if (isModified('businessProjectAction')) {
                            <syn-autocomplete label="Business project" class="autocomplete syn--margin-top"
                                formControlName="businessProject"
                                [dataLoader]="loadBusinessProjectData"
                                [idForInvalidRegex]="businessProjectInvalidIdRegex"
                                [saveIndicator]="false"
                            />
                        }

                        <label class="syn--margin-top">Tags</label>
                        <syn-bulk-edit-toggle
                            formControlName="tagsAction"
                            [options]="modifyOnlyOptions">
                        </syn-bulk-edit-toggle>

                        @if (isModified('tagsAction')) {
                            <div [formGroup]="tagForm">
                                <mat-form-field style="width:100%;" subscriptSizing="dynamic" appearance="outline"
                                    class="syn--margin-top">
                                    <mat-label>Tag à ajouter</mat-label>

                                    <input matInput formControlName="addTag" placeholder="Saisissez des tags"
                                        [matChipInputFor]="addTagsChipGrid" (matChipInputTokenEnd)="addNewTag()" />
                                    <button matSuffix type="button" mat-icon-button (click)="addNewTag()">
                                        <mat-icon svgIcon="plus"></mat-icon>
                                    </button>

                                    <mat-chip-grid class="mat-chip-grid" #addTagsChipGrid>
                                        @for (tag of tagsToAdd; track tag) {
                                        <mat-chip-row class="add-chip" (removed)="removeAddTag(tag)">
                                            {{ tag }}
                                            <button matChipRemove aria-label="'remove_' + tag">
                                                <mat-icon svgIcon="close-circle" />
                                            </button>
                                        </mat-chip-row>
                                        }
                                    </mat-chip-grid>
                                </mat-form-field>

                                <mat-form-field style="width:100%;" subscriptSizing="dynamic" appearance="outline"
                                    class="syn--margin-top">
                                    <mat-label>Tag à supprimer</mat-label>

                                    <input matInput formControlName="removeTag" placeholder="Saisissez des tags"
                                        [matChipInputFor]="removeTagsChipGrid" (matChipInputTokenEnd)="addRemoveTag()" />

                                    <button matSuffix type="button" mat-icon-button (click)="addRemoveTag()">
                                        <mat-icon svgIcon="plus"></mat-icon>
                                    </button>

                                    <mat-chip-grid class="mat-chip-grid" #removeTagsChipGrid>
                                        @for (tag of tagsToRemove; track tag) {
                                        <mat-chip-row class="remove-chip" (removed)="removeRemoveTag(tag)">
                                            {{ tag }}
                                            <button type="button" matChipRemove aria-label="'remove_' + tag">
                                                <mat-icon svgIcon="close-circle" />
                                            </button>
                                        </mat-chip-row>
                                        }
                                    </mat-chip-grid>
                                </mat-form-field>
                            </div>
                        }

                        <label class="syn--margin-top">Metadatas</label>
                        <syn-bulk-edit-toggle
                            formControlName="metadataAction"
                            [options]="modifyOnlyOptions">
                        </syn-bulk-edit-toggle>

                        @if (isModified('metadataAction')) {
                            <p class="label syn--margin-top">Ajouts / modifications</p>

                            <form [formGroup]="addMetadataForm" (ngSubmit)="addMetadata()">
                                <table class="metadata">
                                    @for (metadata of metadatasToAdd; track metadata) {
                                    <tr>
                                        <td>{{ metadata.key }}</td>
                                        <td>{{ metadata.value }}</td>
                                        <td>
                                            <button type="button" mat-icon-button (click)="removeAddMetadata(metadata.key)">
                                                <mat-icon svgIcon="delete-outline"></mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                    }
                                    <tr class="input">
                                        <td>
                                            <input matInput formControlName="key" placeholder="Clé" />
                                        </td>
                                        <td>
                                            <input matInput formControlName="value" placeholder="Valeur" />
                                        </td>
                                        <td>
                                            <button type="submit" mat-icon-button>
                                                <mat-icon svgIcon="plus"></mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </table>
                            </form>

                            <p class="label syn--margin-top">Suppressions</p>

                            <form [formGroup]="removeMetadataForm" (ngSubmit)="removeMetadata()">
                                <table class="metadata">
                                    @for (metadata of metadatasToRemove; track metadata) {
                                    <tr>
                                        <td>{{ metadata }}</td>
                                        <td>
                                            <button type="button" mat-icon-button (click)="removeRemoveMetadata(metadata)">
                                                <mat-icon svgIcon="delete-outline"></mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                    }
                                    <tr class="input">
                                        <td>
                                            <input matInput formControlName="key" placeholder="Clé" />
                                        </td>
                                        <td>
                                            <button type="submit" mat-icon-button>
                                                <mat-icon svgIcon="plus"></mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </table>
                            </form>
                        }
                    }

                    <div class="action-buttons">
                        <button mat-raised-button (click)="stepper.next()" [disabled]="!hasUpdateParameters" color="accent">Continuer</button>
                        <button mat-flat-button (click)="closePanel()">Annuler</button>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step>
            <div class="summary">
                <div class="warning" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon svgIcon="alert-outline" />
                    <div fxLayout="column">
                        <p class="title">Résumé des modifications</p>
                        <p>Les modifications seront appliquées sur {{ projectPluralisation(projects.length) }}.</p>
                    </div>
                </div>
                <table class="syn--margin-top">
                    <tr *ngIf="isChanged('deliveryManagerAction')">
                        <td>Delivery Manager</td>
                        <td>
                            @if (isModified('deliveryManagerAction') && bulkEditForm.get('deliveryManager').value) {
                                {{ entityNameResolver.solve(bulkEditForm.get('deliveryManager').value) }}
                            } @else {
                                @if (isRemoved('deliveryManagerAction')) {
                                    <div class="remove">Retirer</div>
                                }
                            }
                        </td>
                    </tr>
                    <tr *ngIf="isChanged('backupDeliveryManagerAction')">
                        <td>Backup Delivery Manager</td>
                        <td>
                            @if (isModified('backupDeliveryManagerAction') && bulkEditForm.get('backupDeliveryManager').value) {
                                {{ entityNameResolver.solve(bulkEditForm.get('backupDeliveryManager').value) }}
                            } @else {
                                @if (isRemoved('backupDeliveryManagerAction')) {
                                    <div class="remove">Retirer</div>
                                }
                            }
                        </td>
                    </tr>
                    <tr *ngIf="isChanged('buildProjectManagerAction')">
                        <td>CdP Build</td>
                        <td>
                            @if (isModified('buildProjectManagerAction') && bulkEditForm.get('buildProjectManager').value) {
                                {{ entityNameResolver.solve(bulkEditForm.get('buildProjectManager').value) }}
                            } @else {
                                @if (isRemoved('buildProjectManagerAction')) {
                                    <div class="remove">Retirer</div>
                                }
                            }
                        </td>
                    </tr>
                    <tr
                        *ngIf="isAdded('appManagerAction') && bulkEditForm.get('addAppManager').value">
                        <td>Gestionnaire applicatif à ajouter</td>
                        <td>
                            {{ entityNameResolver.solve(bulkEditForm.get('addAppManager').value) }}
                        </td>
                    </tr>
                    <tr
                        *ngIf="isRemoved('appManagerAction') && bulkEditForm.get('removeAppManager').value">
                        <td>Gestionnaire applicatif à supprimer</td>
                        <td>
                            {{ entityNameResolver.solve(bulkEditForm.get('removeAppManager').value) }}
                        </td>
                    </tr>
                    <tr *ngIf="isChanged('businessProjectAction')">
                        <td>Business project</td>
                        <td>
                            @if (isModified('businessProjectAction') && bulkEditForm.get('businessProject').value) {
                                {{ entityNameResolver.solve(bulkEditForm.get('businessProject').value) }}
                            } @else {
                                @if (isRemoved('businessProjectAction')) {
                                    <div class="remove">Retirer</div>
                                }
                            }
                        </td>
                    </tr>
                    <tr *ngIf="isModified('tagsAction') && (tagsToAdd.length > 0 || tagsToRemove.length > 0)">
                        <td>Tags</td>
                        <td>
                            @if (tagsToAdd.length > 0) {
                                <p>Ajouts</p>
                                <mat-chip-set>
                                    @for (tag of tagsToAdd; track tag) {
                                    <mat-chip class="add-chip">{{ tag }}</mat-chip>
                                    }
                                </mat-chip-set>
                            }
                            @if (tagsToRemove.length > 0) {
                                <p>Suppressions</p>
                                <mat-chip-set>
                                    @for (tag of tagsToRemove; track tag) {
                                    <mat-chip class="remove-chip">{{ tag }}</mat-chip>
                                    }
                                </mat-chip-set>
                            }
                        </td>
                    </tr>
                    <tr *ngIf="isModified('metadataAction') && (metadatasToAdd.length > 0 || metadatasToRemove.length > 0)">
                        <td>Metadatas</td>
                        <td>
                            @if (metadatasToAdd.length > 0) {
                                <p>Ajouts / modifications</p>

                                @for (metadata of metadatasToAdd; track metadata) {
                                    <mat-chip class="add-chip">{{ metadata.key }} : {{ metadata.value }}</mat-chip>
                                }
                            }
                            @if (metadatasToRemove.length > 0) {
                                <p>Suppressions</p>

                                @for (metadata of metadatasToRemove; track metadata) {
                                    <mat-chip class="remove-chip">{{ metadata }}</mat-chip>
                                }
                            }
                        </td>
                    </tr>
                </table>
                <div class="action-buttons">
                    <button mat-flat-button type="button" (click)="submit()">Confirmer</button>
                    <button mat-flat-button type="button" (click)="stepper.previous()">Revenir à l'édition</button>
                </div>
            </div>
        </mat-step>

        <mat-step>
            @if (!loading && (updatedProjects.length > 0 || untouchedProjects.length > 0) && projectUpdatedChartData) {
                <div class="pie-chart-container" fxLayout="row" fxLayoutAlign="start center">
                    <div class="pie-chart-graph">
                        <ngx-charts-pie-chart
                            [view]="[120, 120]"
                            [results]="projectUpdatedChartData"
                            [scheme]="projectUpdatedChartScheme"
                            [animations]="true"
                            [tooltipDisabled]="true">
                        </ngx-charts-pie-chart>
                    </div>

                    <div class="pie-chart-legend" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="legend-color modified"></div>
                            <span>
                                @if (updatedProjects.length > 1) {
                                    {{ updatedProjects.length }} projets modifiés
                                } @else {
                                    {{ updatedProjects.length }} projet modifié
                                }
                            </span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="legend-color unchanged"></div>
                            <span>
                                @if (untouchedProjects.length > 1) {
                                    {{ untouchedProjects.length }} projets inchangés
                                } @else {
                                    {{ untouchedProjects.length }} projet inchangé
                                }
                            </span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="legend-color error"></div>
                            <span>
                                @if (errors.length > 1) {
                                    {{ errors.length }} projets en erreur
                                } @else {
                                    {{ errors.length }} projet en erreur
                                }
                            </span>
                        </div>
                    </div>
                </div>
            }

            @if (loading) {
            <mat-list>
                @for (projet of projects; track projet) {
                <mat-list-item>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="label">{{ projet.name }}</span>
                        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="2" color="primary" />
                    </div>
                </mat-list-item>
                <mat-divider />
                }
            </mat-list>
            } @else {
                <mat-accordion class="summary">
                    @if (updatedProjects.length > 0) {
                        <mat-expansion-panel class="mat-elevation-z0 list-project-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                @if (updatedProjects.length > 1) {
                                    <p>{{ updatedProjects.length }} projets <b>modifiés</b></p>
                                } @else {
                                    <p>{{ updatedProjects.length }} projet <b>modifié</b></p>
                                }
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-list>
                                @for (project of updatedProjects; track project) {
                                <mat-list-item>
                                    {{ project.name }}
                                </mat-list-item>
                                <mat-divider />
                                }
                            </mat-list>
                        </mat-expansion-panel>
                    }

                    @if (untouchedProjects.length > 0) {
                        <mat-expansion-panel class="mat-elevation-z0 list-project-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                  @if (untouchedProjects.length > 1) {
                                      <p>{{ untouchedProjects.length }} projets <b>inchangés</b></p>
                                  } @else {
                                      <p>{{ untouchedProjects.length }} projet <b>inchangé</b></p>
                                  }
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-list>
                                @for (project of untouchedProjects; track project) {
                                <mat-list-item>
                                    {{ project.name }}
                                </mat-list-item>
                                <mat-divider />
                                }
                            </mat-list>
                        </mat-expansion-panel>
                    }

                    @if (errors.length > 0) {
                        <mat-expansion-panel class="mat-elevation-z0 list-project-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                  @if (errors.length > 1) {
                                      <p>{{ errors.length }} projets en <b>erreur</b></p>
                                  } @else {
                                      <p>{{ errors.length }} projet en <b>erreur</b></p>
                                  }
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ul>
                                @for (error of errors; track error.project.id) {
                                <li>
                                    <div fxLayout="column">
                                        <span class="label">{{ error.project.name }}</span>
                                        <div class="message">{{ error.error }}</div>
                                    </div>
                                </li>
                                <mat-divider />
                                }
                            </ul>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            }

            <div class="action-buttons">
                <button mat-flat-button [disabled]="loading" (click)="closePanel()">Fermer</button>
            </div>
        </mat-step>
    </mat-stepper>
</form>

<ng-template #userItemTemplate
             let-firstName="content.firstName"
             let-lastName="content.lastName"
             let-fullName="content.fullName"
             let-email="content.email"
             let-isDeleted="content.isDeleted">
    <div [class]="{ 'user_picker_template_deleted': isDeleted }">
        <div class="template_header" *ngIf="fullName">{{ fullName }}<span *ngIf="isDeleted">&nbsp;(Désactivé)</span></div>
        <div class="template_header" *ngIf="!fullName">{{ firstName }} {{ lastName }}<span *ngIf="isDeleted">&nbsp;(Désactivé)</span></div>
        <div class="user_picker_template_subheading">{{ email }}</div>
    </div>
</ng-template>

<ng-template #businessProjectItemTemplate
             let-businessCode="content.businessCode"
             let-businessLabel="content.businessLabel">
    <div>
        <div class="template_header">{{ businessLabel }}</div>
        <div class="template_subheading">{{ businessCode }}</div>
    </div>
</ng-template>
